module.exports={
	"Form": "MixSpecificationCreateManifest",
	"Scope": "MixSpecification-Create",
	"Descriptors":
	{
		"MixSpecificationDetails.Name":
		{
			"Name": "Name",
			"Hash": "MixSpecification-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "MixSpecification-Create-Identity",
				"Group": "MixSpecification-Create-Identity"
			}
		},
		"MixSpecificationDetails.Code":
		{
			"Name": "Code",
			"Hash": "MixSpecification-Create-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "MixSpecification-Create-Identity",
				"Group": "MixSpecification-Create-Identity"
			}
		},
		"MixSpecificationDetails.Description":
		{
			"Name": "Description",
			"Hash": "MixSpecification-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "MixSpecification-Create-Details",
				"Group": "MixSpecification-Create-Details"
			}
		},
		"MixSpecificationDetails.MaterialType":
		{
			"Name": "Material Type",
			"Hash": "MixSpecification-Create-MaterialType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "MixSpecification-Create-Details",
				"Group": "MixSpecification-Create-Details"
			}
		},
		"MixSpecificationDetails.EffectiveDate":
		{
			"Name": "Effective Date",
			"Hash": "MixSpecification-Create-EffectiveDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "MixSpecification-Create-Details",
				"Group": "MixSpecification-Create-Details"
			}
		},
		"MixSpecificationDetails.ExpirationDate":
		{
			"Name": "Expiration Date",
			"Hash": "MixSpecification-Create-ExpirationDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "MixSpecification-Create-Details",
				"Group": "MixSpecification-Create-Details"
			}
		},
		"MixSpecificationDetails.ApprovalDate":
		{
			"Name": "Approval Date",
			"Hash": "MixSpecification-Create-ApprovalDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "MixSpecification-Create-Details",
				"Group": "MixSpecification-Create-Details"
			}
		},
		"MixSpecificationDetails.ApprovingIDUser":
		{
			"Name": "Approving IDUser",
			"Hash": "MixSpecification-Create-ApprovingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "MixSpecification-Create-Details",
				"Group": "MixSpecification-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "MixSpecification-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "MixSpecification-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "MixSpecification-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "MixSpecification-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
